import React from "react";
import { Lg, Xs } from "components/common";
import FicoScoreFactors from "assets/FicoScoreFactors.svg";

const FACTORS_TITLE = "Factors that impact your score";
const FACTORS_BLURB =
  "While lenders look at a variety of factors to determine credit worthiness, these are a few of the most important factors that impact your credit score.";

const CreditFactors = ({ className = "" }) => {
  return (
    <div className={`${className} h-auto p-10`}>
      <Xs to="lg">
        <p className="text-2xl font-bold">
          {FACTORS_TITLE}
        </p>
        <div className="flex flex-col items-center">
          <img src={FicoScoreFactors} alt="TODO" />
          <p className="text-center text-sm">{FACTORS_BLURB}</p>
        </div>
      </Xs>
      <Lg>
        <p className="text-2xl font-bold">
          {FACTORS_TITLE}
        </p>
        <div className="flex flex-row items-center">
          <img
            src={FicoScoreFactors}
            className="w-3/5 mr-16"
            style={{ maxHeight: "24rem" }}
            alt="TODO"
          />
          <p className="w-2/5 h-full">{FACTORS_BLURB}</p>
        </div>
      </Lg>
    </div>
  );
};

export default CreditFactors;
